// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/double-sidewall-double-bottom-template.svg'

export const DoubleSidewallDoubleBottomTemplate = (
  props: React.SVGProps<SVGSVGElement>
) => {
  return <TemplateSVG {...props} />
}
